import axios from 'axios'

function handleResponse(response) {
	if (response.results) {
		return [undefined, response.results]
	}

	if (response.data) {
		if (response.data.data) {
			return [undefined, response.data.data]
		}
		return [undefined, response.data]
	}
	return [undefined, response]
}


function handleError(error) {
	const status = error?.response?.status;

	if (status === 401) {
		sessionStorage.clear()
		delete axios.defaults.headers.common['Authorization']
		window.location.assign('/login')
	}

	if (status === 404) {
		return ["Your account has limited access rights. Please contact your administrator for assistance.", undefined]
	}

	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}

	else {
		return [error, undefined]
	}
}

function handleErrorWithoutRedirect (error){
	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}

	else {
		return [error, undefined]
	}
}

export { handleResponse, handleError, handleErrorWithoutRedirect }
